import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getInvoiceByOrderIdThunk } from '../../../../../../redux/thunk/invoice'

const EMPTY_ORDER_INVOICE = { orderId: null, invoice: null }

export const useOrderInvoice = (orderId, isInvoiceRequested) => {
	const dispatch = useDispatch()
	const [orderInvoice, setOrderInvoice] = useState(EMPTY_ORDER_INVOICE)

	useEffect(() => {
		let isCurrentRequest = true
		setOrderInvoice(EMPTY_ORDER_INVOICE)
		const loadInvoice = async () => {
			const invoice = await dispatch(getInvoiceByOrderIdThunk(orderId))
			if (isCurrentRequest) setOrderInvoice({ orderId, invoice: invoice ?? null })
		}
		if (isInvoiceRequested) loadInvoice()
		return () => {
			isCurrentRequest = false
		}
	}, [dispatch, orderId, isInvoiceRequested])

	const isLoaded = !!isInvoiceRequested && orderInvoice.orderId === orderId

	return {
		invoice: isLoaded ? orderInvoice.invoice : null,
		isLoading: !!isInvoiceRequested && !isLoaded,
	}
}
